export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      // Title
      if(this.title.main.visible == 'Y') {
        this.canvasForms
        .append('text')
        .attr('x', this.title.main.x) .attr('y', this.title.main.y)
        .attr('font-size', this.title.main.tSize).attr('fill', this.title.main.tColor)
        .text(this.title.main.name)
      }

      if(this.title.sub.visible == 'Y') {
        this.canvasForms
        .append('text')
        .attr('x', this.title.sub.x) .attr('y', this.title.sub.y)
        .attr('font-size', this.title.sub.tSize).attr('fill', this.title.sub.tColor)
        .text(this.title.sub.name)
      }
      
      // Average
      let avg = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.trend.x}, ${this.trend.y-10})`)

      avg
      .append('text')
      .attr('id', `AVG_TITLE_${this.localId}`)
      .attr('x', 0) .attr('y', 0).attr('font-size', 10).attr('fill', '#EC407A')
      .text('12 Weeks Average:')

      avg
      .append('text')
      .attr('id', `AVG_VALUE_${this.localId}`)
      .attr('x', this.getNode(`#AVG_TITLE_${this.localId}`, 'width')+5) .attr('y', 0)
      .attr('font-size', 10).attr('fill', '#EC407A')
      .text(this.trend.average)

      // Menu
      let buttons = this.canvasForms
      .append('g')
      .attr('transform', `translate(0.5, 10.5)`)

      let x_ = this.trend.x
      this.items.forEach(d=> {
        d.lineX = x_ - 2
        buttons
        .append('text')
        .attr('id', `BTN_${d.code}`)
        .attr('x', x_) .attr('y', 4)
        .attr('font-size', 11).attr('fill', (d.code==this.current) ? '#44A9DF' : '#bcbcbc')
        .attr('opacity', 1)
        .text(d.name)
        .call(this.call_Button, d)

        if(d.code==this.current) {
          buttons
          .append('rect')
          .attr('id', `LINE_${this.localId}`)
          .attr('x', x_ - 2).attr('y', 8)
          .attr('width', this.getNode(`#BTN_${d.code}`, 'width')+4).attr('height', 1)
          .attr('fill', '#44A9DF').attr('stroke-width', 0)
        }
        x_ = x_ + this.getNode(`#BTN_${d.code}`, 'width') + 20
      })


      this.draw_ChartCanvas() // -----> draw_Elements.js
      this.draw_Timeline() // -----> draw_Timeline.js
      this.draw_barChart() // -----> draw_Chart.js

      let wData = this.weekData.filter(f=> f[this.ref.item]==this.current)

      this.set_WeekPerformance(this.canvasForms, wData)


      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },

  }
}
           